/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
import '../../../../../../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "common": {
                            "nested": {
                              "OfflinePaymentOption": {
                                "values": {
                                  "CASH_AND_CARD": 1,
                                  "CASH_ONLY": 2
                                }
                              },
                              "StoreAndForward": {
                                "fields": {
                                  "enabled": {
                                    "type": "bool",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "singleTransactionLimit": {
                                    "type": ".squareup.common.Money",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "squareOutagePaymentOption": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.OfflinePaymentOption",
                                    "id": 3,
                                    "rule": "optional",
                                    "options": {
                                      "default": "CASH_ONLY"
                                    }
                                  },
                                  "networkOutagePaymentOption": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.OfflinePaymentOption",
                                    "id": 4,
                                    "rule": "optional",
                                    "options": {
                                      "default": "CASH_ONLY"
                                    }
                                  },
                                  "runtimeBehavior": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.StoreAndForward.StoreAndForwardRuntimeBehavior",
                                    "id": 5,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "StoreAndForwardRuntimeBehavior": {
                                    "fields": {
                                      "showEnablementPromptModal": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional",
                                        "options": {
                                          "default": false
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.OfflinePaymentOption && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.StoreAndForward && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.StoreAndForward?.nested?.StoreAndForwardRuntimeBehavior) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE OfflinePaymentOption @ squareup/devicesettings/profiles/v2/model/settings/common/store_and_forward.proto at 11:1
 */
export const OfflinePaymentOption = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.common.OfflinePaymentOption').values;
/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE StoreAndForward @ squareup/devicesettings/profiles/v2/model/settings/common/store_and_forward.proto at 26:1
 */
export const StoreAndForward = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.StoreAndForward');
fixType(StoreAndForward);
Builder.createAndAttachToType(StoreAndForward);
/**
 * SOURCE StoreAndForwardRuntimeBehavior @ squareup/devicesettings/profiles/v2/model/settings/common/store_and_forward.proto at 39:3
 */
StoreAndForward.StoreAndForwardRuntimeBehavior = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.StoreAndForward.StoreAndForwardRuntimeBehavior');
fixType(StoreAndForward.StoreAndForwardRuntimeBehavior);
Builder.createAndAttachToType(StoreAndForward.StoreAndForwardRuntimeBehavior);